import { render, staticRenderFns } from "./GoodsFrom.vue?vue&type=template&id=2289dcb1&scoped=true&"
import script from "./GoodsFrom.vue?vue&type=script&lang=js&"
export * from "./GoodsFrom.vue?vue&type=script&lang=js&"
import style0 from "./GoodsFrom.vue?vue&type=style&index=0&id=2289dcb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2289dcb1",
  null
  
)

export default component.exports